<template>
  <div class="newsIndex">
    <top :titleHide="true" />
    <div class="common_content">
      <div>
        <el-row :gutter="10" style="margin-top:10px;margin-bottom:10px">
          <el-col :xs="12" :sm="8" :md="8">
            <div class="block">
              <el-date-picker
                v-model="testTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;"
              ></el-date-picker>
            </div>
          </el-col>
          <el-col :xs="12" :sm="8" :md="8">
            <div>
              <el-input placeholder="输入要搜索的内容" v-model="keyword">
                <el-button slot="append" @click="search">
                  <i class="el-icon-search" style="font-size:16px"></i>
                </el-button>
              </el-input>
            </div>
          </el-col>
        </el-row>
        <div class="list" v-if="totalCount">
          <ul>
            <li v-for="(item,index) in data" :key="index">
              <div class="nrow" @click="getInto(item.id)">
                <el-row :gutter="10">
                  <el-col :xs="16" :sm="19" :md="19">
                    <div class="ellipsis">
                      <span class="dian"></span>
                      <span class="content">{{item.news_subject}}</span>
                    </div>
                  </el-col>
                  <el-col :xs="8" :sm="5" :md="5">
                    <div class="time">{{item.publish_date|dateformat('YYYY-MM-DD HH:mm:ss')}}</div>
                  </el-col>
                </el-row>
              </div>
            </li>
          </ul>
        </div>
        <no-data v-else />
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="paging.limit"
            v-if="totalCount>20"
            :total="totalCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import top from "@/views/admin/components/top.vue";
import noData from "@/views/admin/components/noData.vue";
import { GetNewsList } from "@/api/admin/common.js";
export default {
  components: {
    top,
    noData
  },
  data() {
    return {
      keyword: "",
      testTime: "",
      data: [],
      totalCount: 0,
      paging: {
        limit: 20,
        page: 1
      },
      id: 0,
      Time:[],
      condition:{}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getInto(newsId) {
      this.id = newsId;
      this.$router.push({
        path: "/news/newsDetails",
        query: { id: this.id }
      });
    },
    getList() {
      // 新闻列表
      GetNewsList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
          this.totalCount = list.totalCount;
        }
      });
    },
    // 分页
    handleCurrentChange(cpage) {
      this.paging.page = cpage;
      GetNewsList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
        }
      });
    },
    // 搜索
    search() {
      if(this.testTime){
         this.testTime[0]= this.testTime[0]+ " 00:00:00",
         this.testTime[1]= this.testTime[1]+ " 23:59:59",
         this.condition = {
          keyword: this.keyword,
          startTime: this.testTime[0],
          endTime: this.testTime[1]
        };
         this.searchCon();
      }
      else{
         this.condition = {
          startTime: '',
          endTime: '', 
          keyword: this.keyword
        };
        this.searchCon();
      }
    },
    searchCon(){
      GetNewsList(Object.assign(this.paging,this.condition)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
          this.totalCount = list.totalCount; 
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.newsIndex {
  .list {
    .nrow {
      line-height: 1;
      padding-top: 15px;
      padding-bottom: 15px;
      border-bottom: 1px dotted #ddd;
      .ellipsis {
        display: flex;
        align-items: center;
        .dian {
          width: 5px;
          height: 5px;
          background-color: #000;
          border-radius: 50%;
          margin-right: 5px;
        }
        .content {
          width: 100%;
          font-size: 18px;
          color: #000;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .time {
        text-align: right;
        color: #999;
      }
    }
    .nrow:hover {
      cursor: pointer;
      .content {
        color: #ea0000;
      }
    }
  }
  .pagination {
    margin: 50px 0px;
    text-align: center;
  }
}
@media screen and (max-width: 767px) {
  .newsIndex {
    .list {
      .nrow {
        .ellipsis {
          .content {
            font-size: 16px;
          }
        }
        .time {
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
